var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableBenchC = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 62 26",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M61.12 2.24v22.08l-4.64.464a1.6 1.6 0 0 1-1.76-1.592V8.64a1.6 1.6 0 0 0-1.6-1.6H21.99a1.6 1.6 0 0 1-1.585-1.814l.62-4.586H59.52a1.6 1.6 0 0 1 1.6 1.6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M61.12 25.6a.64.64 0 0 0 .64-.64V2.24A2.24 2.24 0 0 0 59.52 0H20.16a.64.64 0 0 0 0 1.28h39.36c.53 0 .96.43.96.96v22.72c0 .354.286.64.64.64Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M18.24 20.16a1.6 1.6 0 0 0 1.6 1.6H51.2a1.6 1.6 0 0 0 1.6-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6H19.84a1.6 1.6 0 0 0-1.6 1.6v9.6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M.64 2.24v22.08l4.64.464a1.6 1.6 0 0 0 1.76-1.592V8.64a1.6 1.6 0 0 1 1.6-1.6h31.129a1.6 1.6 0 0 0 1.585-1.814L40.734.64H2.24a1.6 1.6 0 0 0-1.6 1.6Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M.64 25.6a.64.64 0 0 1-.64-.64V2.24A2.24 2.24 0 0 1 2.24 0H41.6a.64.64 0 1 1 0 1.28H2.24a.96.96 0 0 0-.96.96v22.72a.64.64 0 0 1-.64.64Z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M43.52 20.16a1.6 1.6 0 0 1-1.6 1.6H10.56a1.6 1.6 0 0 1-1.6-1.6v-9.6a1.6 1.6 0 0 1 1.6-1.6h31.36a1.6 1.6 0 0 1 1.6 1.6v9.6Z"
})));
SvgNoTableBenchC.viewBox = '0 0 62 26';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableBenchC);
export default ForwardRef;